import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { PriceDisplay } from './PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component is used to display a price in a given currency with the per month term.
 * For example, "50/mo" or "50/mo/seat"
 * It differs from the PriceDisplayWithTerm component in that it takes the final price as a prop
 * rather than the PricingInfo object.
 * This should be a bare-bones component that does not have any additional styling.
 * Any additional styling should be done in the calling component.
 */

export const PricePerMonth = ({
  price,
  showPricePerMonthPerSeat,
  seleniumId,
  currencyCode,
  currencyCodeUnit
}) => {
  const options = {
    price: /*#__PURE__*/_jsx(PriceDisplay, {
      price: price,
      currencyCode: currencyCode,
      dataSelenium: `${seleniumId}-price-per-month`,
      currencyCodeUnit: currencyCodeUnit
    })
  };
  return showPricePerMonthPerSeat ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "priceComponents.pricePerMonthPerSeat",
    options: options
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "priceComponents.pricePerMonth",
    options: options
  });
};